/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { PLAY_BLOCK_TYPE } from 'adv-protocol/src/GameCommon'
// image
import ClockImg from '@assets/images/bg/clock.png'
// css
import { NoAccessWrap } from './indes.style'
import dayjs from 'dayjs'

const NoAccess: React.FC = () => {

  const { authStore } = useRootStore()

  const playBlockType = authStore?.userInfo?.playBlockType
  const playBlockTime = authStore?.userInfo?.playBlockTime

  const toDateTemplate = (time: Date) => {
    let format = ''

    switch (playBlockType) {
      case PLAY_BLOCK_TYPE.LOSS_LIMIT_EXCEEDED:
        format = 'MM/DD HH:mm'
        break
      case PLAY_BLOCK_TYPE.SELF_SET_USAGE_RESTRICTIONS:
        format = 'YYYY/MM/DD HH:mm'
        break
      default:
        format = 'YYYY/MM/DD HH:mm'
    }

    return dayjs(time).format(format)
  }

  return (
    <NoAccessWrap>
      <img src={ClockImg} alt="시계 이미지" className="no-access-img"/>
      <p className="point-color--yellow">
        {toDateTemplate(playBlockTime)} 이후 접속 가능
      </p>
      {playBlockType === PLAY_BLOCK_TYPE.LOSS_LIMIT_EXCEEDED && (
        <p className="explain-txt">
          1일 손실한도를 초과했습니다.
          <br/>
          6시간 동안 게임 접속이 제한됩니다.
        </p>)}

      {playBlockType === PLAY_BLOCK_TYPE.SELF_SET_USAGE_RESTRICTIONS && (<p className="explain-txt">
        이용 제한 설정이 적용된 계정입니다.
        <br/>
        지정 기간 동안 접속이 제한됩니다.
      </p>)}
    </NoAccessWrap>
  )
}
export default observer(NoAccess)
